export default __webpack_public_path__ + "s6.png";